import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { getEnvironmentConfig } from "@/config/domainConfigLoader";

// Les garants ne sont pas authentifiés sur gestion-sav (rôles internes uniquement) :
// leur dossier SAV vit sur l'outil pro V2 (/sav/:id, authentifié externe). On redirige
// donc l'ancien lien mail `/garant/sav/:id` vers l'outil-pro, avec le raccourci
// `redirect_to_validation=true` qui auto-ouvre la validation si le garant est éligible.
export default function RedirectOutilsProSav() {
  const { id } = useParams();

  useEffect(() => {
    const proUrl = getEnvironmentConfig().PRO_URL_V2;
    if (!proUrl) {
      console.error("[RedirectOutilsProSav] PRO_URL_V2 non configurée pour ce domaine : redirection vers l'outil pro impossible.");
      return;
    }
    const base = proUrl.replace(/\/+$/, "");
    setTimeout(() => {
      window.location.href = `${base}/sav/${id}?redirect_to_validation=true`;
    }, 0);
  }, [id]);

  return null;
}
